import { service } from '@ember/service'
import Component from '@glimmer/component'
import RouteTemplate from 'ember-route-template'
import type WritingLegendsVocabularyBankNewWordsRoute from 'teacher-ui-client/reporting/ui-scope/writing-legends/vocabulary/bank/new-words/route'
import type ReportingService from 'teacher-ui-client/services/reporting'
import { queryParam } from 'teacher-ui-client/decorators/query-param'
import { trackedFunction } from 'reactiveweb/function'
import { toRequestScope } from 'teacher-ui-client/services/reporting'
import { Product } from 'teacher-ui-client/utils/products'
import { use } from 'ember-resources'
import { keepLatest } from 'reactiveweb/keep-latest'
import ContentTile from 'teacher-ui-client/components/tiles/content'
import {
  VocabularyUsageTable,
  type VocabularyStudentWordsUsage,
} from 'teacher-ui-client/components/writing-legends/tables/vocabulary-usage-table'
import NoReportValue from 'teacher-ui-client/components/reporting/no-report-value'
import { t } from 'ember-intl'
import { array } from '@ember/helper'
import NoDataMessage from 'teacher-ui-client/components/no-data-message'

interface Signature {
  Args: {
    model: ModelFor<WritingLegendsVocabularyBankNewWordsRoute>
  }
}

export class WritingLegendsVocabularyBankNewWordsPage extends Component<Signature> {
  @queryParam('reporting/ui-scope/writing-legends/vocabulary/bank') sort!: string

  @service reporting!: ReportingService

  fetchData = trackedFunction(this, () => {
    const requestScope = toRequestScope(this.args.model.uiScope)

    const url = this.reporting.buildWritingLegendsUrl({
      product: Product.WL,
      requestScope,
      reportName: 'vocabulary/new-words',
    })

    const query = this.reporting.buildQuery({
      sort: this.sort,
      period: this.args.model.period,
    })

    return this.reporting.fetchReport<VocabularyStudentWordsUsage>(url, query)
  })

  @use
  latestData = keepLatest({
    value: () => this.fetchData.value,
    when: () => this.fetchData.isPending,
  }); /* prettier-ignore */ /* prettier-ignore-end */

  get isUnsupportedScope() {
    const requestScope = toRequestScope(this.args.model.uiScope)
    return requestScope.scope !== 'school-class'
  }
  <template>
    {{#if this.isUnsupportedScope}}
      <NoDataMessage
        @compact={{true}}
        @body={{t "components.noDataMessage.limitedScope" scope="class" htmlSafe=true}}
        class="m-4"
      />
    {{else if this.latestData}}
      <ContentTile>
        <VocabularyUsageTable
          class="w-full"
          @isReloading={{this.fetchData.isPending}}
          @vocabularyData={{this.latestData}}
          @infoTooltip={{t "pages.wlVocabulary.bank.tooltips.newWords"}}
        />
      </ContentTile>
    {{else}}
      <NoReportValue @reportStates={{array this.fetchData}} />
    {{/if}}
  </template>
}

export default RouteTemplate(WritingLegendsVocabularyBankNewWordsPage)
